import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";
import type { Query } from "@tanstack/react-query";
import { rqIdbStorage } from "@/lib/rqIdbStorage";

const PERSISTER_KEY = "deeply-smart-react-query";

const persister = createAsyncStoragePersister({
  storage: rqIdbStorage,
  key: PERSISTER_KEY,
  throttleTime: 1000,
});

function shouldDehydrateQuery(query: Query): boolean {
  const root = query.queryKey[0];
  return root === "knowledgebase-item" || root === "knowledgebase-summary";
}

/** Persist only KB list + full items to IndexedDB; max age bounds stale restores. */
export const kbPersistOptions: Omit<PersistQueryClientOptions, "queryClient"> = {
  persister,
  maxAge: 1000 * 60 * 60 * 24 * 7, // 7 days
  dehydrateOptions: {
    shouldDehydrateQuery,
  },
};
